import { createQueryKeys } from '@lukemorales/query-key-factory';

export const productOnboarding = createQueryKeys('product-onboarding', {
	record: (id: string) => ({
		queryKey: [id],
	}),
	pricing: (svpId?: string) => ({
		queryKey: [svpId ?? 'default'],
	}),
});
